import type { BannerData, UpdateLifecycle } from '@layers/web/composables/types/banner.ts'

export const useBanner = () => {
  const rootStore = useRootStore()

  const { previousRoute } = storeToRefs(rootStore)

  let pageBannerData: BannerData | null = null

  let updateInClientLifecycle: UpdateLifecycle = 'mounted'

  const updatePageBanner = (): void => {
    if (pageBannerData) {
      rootStore.setPageBanner(pageBannerData)
    }
  }

  onBeforeMount(() => {
    if (updateInClientLifecycle !== 'beforeMount') {
      return
    }

    updatePageBanner()
  })

  onMounted(() => {
    if (updateInClientLifecycle !== 'mounted') {
      return
    }

    updatePageBanner()
  })

  const route = useRoute()

  /**
   * Made to sync updates in layout banner with page change
   */
  const setPageBanner = (bannerData: BannerData, onlyClient?: boolean): void => {
    if (!onlyClient && import.meta.server) {
      rootStore.setPageBanner(bannerData)
      return
    }

    if (previousRoute.value && previousRoute.value.name === route.name) {
      updateInClientLifecycle = 'beforeMount'
    }

    pageBannerData = deepClone(bannerData)
  }

  return {
    setPageBanner,
  }
}